import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ExerciseService } from '../exercise.service';

import { of } from "rxjs";


@Injectable()
export class ExerciseDetailResolver implements Resolve<Observable<string>> {

  constructor(private exerciseService: ExerciseService) { }

  resolve(route: ActivatedRouteSnapshot) {
    if (route.paramMap.get('id') !== 'new') {
      return this.exerciseService.getExercise(Number(route.paramMap.get('id'))).catch(() => {
        return of('error');
      });
    } else {
      return of('new');
    }
  }
}

